export default __webpack_public_path__ + "static/media/blades.38f29dda.png";